import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Snack from '@material-ui/core/SnackbarContent';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import Close from '@material-ui/icons/Close';
import snackbarContentStyle from '../../assets/jss/material-kit-react/components/snackbarContentStyle';
class SnackbarContent extends React.Component {
    constructor(props) {
        super(props);
        this.closeAlert = this.closeAlert.bind(this);
        const { classes, message, color, close, icon } = props;
        var action = [];
        if (close !== undefined) {
            action = [
                React.createElement(IconButton, { className: classes.iconButton, key: "close", "aria-label": "Close", color: "inherit", onClick: this.closeAlert },
                    React.createElement(Close, { className: classes.close })),
            ];
        }
        let snackIcon = null;
        switch (typeof icon) {
            case 'function':
                snackIcon = React.createElement(props.icon, { className: classes.icon });
                break;
            case 'string':
                snackIcon = React.createElement(Icon, { className: classes.icon }, props.icon);
                break;
            default:
                snackIcon = null;
                break;
        }
        this.state = {
            alert: (React.createElement(Snack, { message: React.createElement("div", null,
                    snackIcon,
                    message,
                    close !== undefined ? action : null), classes: {
                    root: classes.root + ' ' + classes[color],
                    message: classes.message + ' ' + classes.container,
                } })),
        };
    }
    closeAlert() {
        this.setState({ alert: null });
    }
    render() {
        return this.state.alert;
    }
}
SnackbarContent.propTypes = {
    classes: PropTypes.object.isRequired,
    message: PropTypes.node.isRequired,
    color: PropTypes.oneOf(['info', 'success', 'warning', 'danger', 'primary']),
    close: PropTypes.bool,
    icon: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
};
export default withStyles(snackbarContentStyle)(SnackbarContent);
//# sourceMappingURL=SnackbarContent.js.map